var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slide',{ref:"slide",staticClass:"slide",attrs:{"background":_vm.colors.$marine_dark}},[_c('ProffesionGraphic',{staticClass:"illustration",attrs:{"animationPercentage":_vm.entered,"start":_vm.timelinePosition.start,"end":_vm.end}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }